import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'

import { IDataProviderFilter, IFilter, Logic, Operator } from 'core-components/types'

import { getVersionCrud } from './getVersionCrud'

interface IGetPrevEltVersion {
  partnerId: string | null
  groupId: number | null
  eltType: EltType
  currentEntryId: number
}
export const getPrevEltVersionPictures = async ({
  partnerId,
  eltType,
  groupId,
  currentEntryId,
}: IGetPrevEltVersion): Promise<IELTData | null> => {
  const crud = getVersionCrud('getPrevEltVersionPictures')
  crud.setSort({ field: 'EntryId', dir: 'desc' })
  crud.setPaging({ pageSize: 1, page: 0 })
  const filters: (IFilter | IDataProviderFilter)[] = [
    {
      field: 'EltType',
      value: eltType,
      operator: Operator.EQUAL,
    },
    {
      field: 'EntryId',
      value: currentEntryId,
      operator: Operator.NOTEQUAL,
    },
    {
      logic: Logic.OR,
      filters: [
        {
          logic: Logic.AND,
          filters: [
            {
              field: 'Picture',
              operator: Operator.ISNOTNULL,
              value: '',
            },
            {
              field: 'Picture',
              value: '',
              operator: Operator.NOTEQUAL,
            },
          ],
        },
        {
          logic: Logic.AND,
          filters: [
            {
              field: 'Logo',
              operator: Operator.ISNOTNULL,
              value: '',
            },
            {
              field: 'Logo',
              value: '',
              operator: Operator.NOTEQUAL,
            },
          ],
        },
      ],
    },
  ]

  if (partnerId) {
    filters.push({
      field: 'PartnerId',
      value: partnerId,
      operator: Operator.EQUAL,
    })
  }

  if (groupId) {
    filters.push({
      field: 'GroupId',
      value: groupId,
      operator: Operator.EQUAL,
    })
  }

  crud.setFilter({
    logic: Logic.AND,
    filters: filters,
  })

  const res = await crud.fetch({ force: true })
  return res?.items[0] || null
}
